import React from 'react'
import classes from './SchoolDetails.module.css'
const SchoolDetails = ({ avatar, schoolName, margin }) => {
  return (
    <div
      style={{
        margin: margin,
      }}
      className={classes.container}
    >
      <div className={classes.avatarbox}>
        <img src={avatar} alt={'chalkwide'} className={classes.avatar} />
      </div>
      <p className={classes.txt}>{schoolName}</p>
    </div>
  )
}

export default SchoolDetails
